var _line, _line2, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvailabilitiesIconGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 6.5,
    x2: 9.5,
    y2: 5.5,
    stroke: "#008C15",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 6.5,
    x2: 15.5,
    y2: 5.5,
    stroke: "#008C15",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.5L12.5 15.5L15.5 12.5",
    stroke: "#008C15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 8.5H5.5L5.5 18.5H19.5V8.5ZM5.5 6.5C4.39543 6.5 3.5 7.39543 3.5 8.5V18.5C3.5 19.6046 4.39543 20.5 5.5 20.5H19.5C20.6046 20.5 21.5 19.6046 21.5 18.5V8.5C21.5 7.39543 20.6046 6.5 19.5 6.5H5.5Z",
    fill: "#008C15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 7.5C8.94772 7.5 8.5 7.05228 8.5 6.5L8.5 5.5C8.5 4.94772 8.94772 4.5 9.5 4.5C10.0523 4.5 10.5 4.94772 10.5 5.5L10.5 6.5C10.5 7.05228 10.0523 7.5 9.5 7.5Z",
    fill: "#008C15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 7.5C14.9477 7.5 14.5 7.05228 14.5 6.5L14.5 5.5C14.5 4.94772 14.9477 4.5 15.5 4.5C16.0523 4.5 16.5 4.94772 16.5 5.5L16.5 6.5C16.5 7.05228 16.0523 7.5 15.5 7.5Z",
    fill: "#008C15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7929 11.7929C15.1834 11.4024 15.8166 11.4024 16.2071 11.7929C16.5976 12.1834 16.5976 12.8166 16.2071 13.2071L13.2071 16.2071C12.8166 16.5976 12.1834 16.5976 11.7929 16.2071L9.79289 14.2071C9.40237 13.8166 9.40237 13.1834 9.79289 12.7929C10.1834 12.4024 10.8166 12.4024 11.2071 12.7929L12.5 14.0858L14.7929 11.7929Z",
    fill: "#008C15"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailabilitiesIconGreen);
export default __webpack_public_path__ + "static/media/AvailabilitiesIconGreen.3ebb353df5c55a897b4d87657c9cb114.svg";
export { ForwardRef as ReactComponent };